import PicklistMetadata from "../PicklistMetadata";

// The subject a record is filed under. Non-static: domains are tenant data, edited on the Domains
// screen, so the list comes from the DataDomain EC rather than from PICK_VALUES.
//
// ALLOWS NO SELECTION, deliberately. Unfiled is a real answer -- most records are unfiled and that
// is truthful -- so the picker has to offer a way back to it, or the first person who opens the
// dropdown by accident can never undo it.
class DataDomainPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "DataDomain";
        this.static = false;
        this.enterpriseComponent = "DataDomain";
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = [{SortAttribute: "Name", Direction: "ASC"}];
        this.typeField = "Name";
        this.typeValue = "USID";
        this.allowNoSelection = true;
    }
}

export default DataDomainPicklistMetadata;
